var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 121,
    viewBox: "0 0 122 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SF Symbol / checkmark.circle",
    d: "M40.0534 62.2612L55.0691 79.6479C55.5228 80.1732 56.3486 80.1261 56.7315 79.5473C59.482 75.3892 69.1341 60.8139 76.082 50.531M117.976 60.5855C117.976 92.0522 92.467 117.561 61.0003 117.561C29.5335 117.561 4.02466 92.0522 4.02466 60.5855C4.02466 29.1187 29.5335 3.60986 61.0003 3.60986C92.467 3.60986 117.976 29.1187 117.976 60.5855Z",
    stroke: "#047857",
    strokeWidth: 6.28266,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.d21a792aa18b2416ad3b8fd4f4d689fc.svg";
export { ForwardRef as ReactComponent };